

export function useGuestMode(feature) {
  return {
    isGuest: false,
    guestUsage: 0,
    remainingUses: Infinity,
    hasReachedLimit: false,
    incrementUsage: () => true,
    resetUsage: () => {},
    showLimitModal: false,
    setShowLimitModal: () => {},
  };
}
